var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 11.5C0 5.14873 5.14873 0 11.5 0C17.8513 0 23 5.14873 23 11.5C23 17.8513 17.8513 23 11.5 23C5.14873 23 0 17.8513 0 11.5Z",
    fill: "#DE4BCD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.1139 8.1139C8.26577 7.96203 8.512 7.96203 8.66387 8.1139L11.5 10.95L14.3361 8.1139C14.488 7.96203 14.7342 7.96203 14.8861 8.1139C15.038 8.26577 15.038 8.512 14.8861 8.66387L12.05 11.5L14.8861 14.3361C15.038 14.488 15.038 14.7342 14.8861 14.8861C14.7342 15.038 14.488 15.038 14.3361 14.8861L11.5 12.05L8.66387 14.8861C8.512 15.038 8.26577 15.038 8.1139 14.8861C7.96203 14.7342 7.96203 14.488 8.1139 14.3361L10.95 11.5L8.1139 8.66387C7.96203 8.512 7.96203 8.26577 8.1139 8.1139Z",
    fill: "#FFE7FE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClose);
export default __webpack_public_path__ + "static/media/icon_close.162fcfe39357fd3e0a2346e2b91dbf57.svg";
export { ForwardRef as ReactComponent };